function AlphaBackground( attributes, keyName, defaultValue = '#fff' ) {
	if ( keyName in attributes && attributes[ keyName ].type ) {
		let background =
			attributes[ keyName ].type === 'color'
				? attributes[ keyName ][ 'color' ]
				: attributes[ keyName ][ 'gradient' ];
		return background;
	}
	return defaultValue;
}

function AlphaBackgroundCSS( attributes, keyName, defaultValue = '#fff' ) {
	let alphaValue = AlphaBackground(
		attributes,
		keyName,
		( defaultValue = '#fff' )
	);
	let colorImage = '';
	if ( keyName in attributes && attributes[ keyName ].type ) {
		if ( attributes[ keyName ].type == 'gradient' ) {
			colorImage = { backgroundImage: alphaValue };
		} else {
			colorImage = { backgroundColor: alphaValue };
		}
	}
	return colorImage;
}
function camelToKebab( str ) {
	return str.replace( /([a-z])([A-Z])/g, '$1-$2' ).toLowerCase();
}

function AlphaFourDCss(
	attributes,
	keyName,
	attrName = 'padding',
	cssLeft = []
) {
	let fourCss = {};
	let [
		leftOne = `${ attrName }-top`,
		leftTwo = `${ attrName }-right`,
		leftThree = `${ attrName }-bottom`,
		leftFour = `${ attrName }-left`,
	] = cssLeft;

	if ( keyName in attributes ) {
		if ( 'desktop' in attributes[ keyName ] ) {
			fourCss[ 'initial' ] = {
				[ `${ leftOne }` ]:
					`${ attributes[ keyName ]?.desktop?.sideTop }` +
					attributes[ keyName ]?.desktop?.unit,
				[ `${ leftTwo }` ]:
					`${ attributes[ keyName ]?.desktop?.sideRight }` +
					attributes[ keyName ]?.desktop?.unit,
				[ `${ leftThree }` ]:
					`${ attributes[ keyName ]?.desktop?.sideBottom }` +
					attributes[ keyName ]?.desktop?.unit,
				[ `${ leftFour }` ]:
					`${ attributes[ keyName ]?.desktop?.sideLeft }` +
					attributes[ keyName ]?.desktop?.unit,
			};
		}
		if ( 'laptop' in attributes[ keyName ] ) {
			fourCss[ 'md' ] = {
				[ `${ leftOne }` ]:
					`${ attributes[ keyName ]?.laptop?.sideTop }` +
					attributes[ keyName ]?.laptop?.unit,
				[ `${ leftTwo }` ]:
					`${ attributes[ keyName ]?.laptop?.sideRight }` +
					attributes[ keyName ]?.laptop?.unit,
				[ `${ leftThree }` ]:
					`${ attributes[ keyName ]?.laptop?.sideBottom }` +
					attributes[ keyName ]?.laptop?.unit,
				[ `${ leftFour }` ]:
					`${ attributes[ keyName ]?.laptop?.sideLeft }` +
					attributes[ keyName ]?.laptop?.unit,
			};
		}
		if ( 'mobile' in attributes[ keyName ] ) {
			fourCss[ 'sm' ] = {
				[ `${ leftOne }` ]:
					`${ attributes[ keyName ]?.mobile?.sideTop }` +
					attributes[ keyName ]?.mobile?.unit,
				[ `${ leftTwo }` ]:
					`${ attributes[ keyName ]?.mobile?.sideRight }` +
					attributes[ keyName ]?.mobile?.unit,
				[ `${ leftThree }` ]:
					`${ attributes[ keyName ]?.mobile?.sideBottom }` +
					attributes[ keyName ]?.mobile?.unit,
				[ `${ leftFour }` ]:
					`${ attributes[ keyName ]?.mobile?.sideLeft }` +
					attributes[ keyName ]?.mobile?.unit,
			};
		}
	}
	return fourCss;
}

function AlphaOneDControl( attributes, keyName, attrName = 'b' ) {
	let oneD = {};

	if ( keyName in attributes ) {
		if ( 'desktop' in attributes[ keyName ] ) {
			oneD = {
				...oneD,
				[ `--lg-${ attrName }` ]:
					`${ attributes[ keyName ]?.desktop?.val }` +
					attributes[ keyName ]?.desktop?.unit,
			};
		}
		if ( 'laptop' in attributes[ keyName ] ) {
			oneD = {
				...oneD,
				[ `--md-${ attrName }` ]:
					`${ attributes[ keyName ]?.laptop?.val }` +
					attributes[ keyName ]?.laptop?.unit,
			};
		}
		if ( 'mobile' in attributes[ keyName ] ) {
			oneD = {
				...oneD,
				[ `--sm-${ attrName }` ]:
					`${ attributes[ keyName ]?.mobile?.val }` +
					attributes[ keyName ]?.mobile?.unit,
			};
		}
	}
	return oneD;
}

function AlphaOneDCss( attributes, keyName, attrName = 'b' ) {
	let oneCss = {};

	if ( keyName in attributes ) {
		if ( 'desktop' in attributes[ keyName ] ) {
			oneCss[ 'initial' ] = {
				[ `${ attrName }` ]:
					`${ attributes[ keyName ]?.desktop?.val }` +
					attributes[ keyName ]?.desktop?.unit,
			};
		}
		if ( 'laptop' in attributes[ keyName ] ) {
			oneCss[ 'md' ] = {
				[ `${ attrName }` ]:
					`${ attributes[ keyName ]?.laptop?.val }` +
					attributes[ keyName ]?.laptop?.unit,
			};
		}
		if ( 'mobile' in attributes[ keyName ] ) {
			oneCss[ 'sm' ] = {
				[ `${ attrName }` ]:
					`${ attributes[ keyName ]?.mobile?.val }` +
					attributes[ keyName ]?.mobile?.unit,
			};
		}
	}
	return oneCss;
}

function displayControl(
	hideOnDesktop = false,
	hideOnTablet = false,
	hideOnMobile = false
) {
	let oneCss = {};

	if ( hideOnDesktop ) {
		oneCss[ 'lg' ] = {
			[ `display` ]: `none`,
		};
	}
	if ( hideOnTablet ) {
		oneCss[ 'md' ] = {
			[ `display` ]: `none`,
		};
	}
	if ( hideOnMobile ) {
		oneCss[ 'sm' ] = {
			[ `display` ]: `none`,
		};
	}
	return oneCss;
}

function AlphaOptionControl(
	attributes,
	keyName,
	defaultValue = false,
	prevKeyName = false
) {
	let optionCSS = {};
	// let _kebabKeyName = camelToKebab(keyName);
	let _kebabKeyName =
		( prevKeyName ? camelToKebab( prevKeyName ) : '' ) +
		'-' +
		camelToKebab( keyName );
	if ( keyName in attributes ) {
		optionCSS = {
			...optionCSS,
			[ `--${ _kebabKeyName }` ]: `${ attributes[ keyName ] ?? '' }`,
		};
	} else if ( defaultValue ) {
		optionCSS = { [ `--${ _kebabKeyName }` ]: defaultValue };
	}
	return optionCSS;
}

function AlphaBorderStyleCSS( attributes, keyName, defaultValue = false ) {
	let CSS = {};

	if ( keyName in attributes ) {
		CSS = {
			...CSS,
			[ `border-style` ]: `${ attributes[ keyName ] ?? '' }`,
		};
	} else if ( defaultValue ) {
		CSS = { [ `border-style` ]: defaultValue };
	}
	return { [ 'initial' ]: CSS };
}

function CSS( styleName, value ) {
	let css = {};
	if (
		styleName &&
		value &&
		typeof styleName === 'string' &&
		typeof value === 'string'
	) {
		css = { [ styleName ]: value };
		return { [ 'initial' ]: css };
	}
	if ( typeof value === 'object' ) {
		let oneCss = {};
		if ( 'desktop' in value ) {
			oneCss[ 'initial' ] = {
				[ styleName ]: value[ 'desktop' ],
			};
		}
		if ( 'tablet' in value ) {
			oneCss[ 'md' ] = {
				[ styleName ]: value[ 'tablet' ],
			};
		}
		if ( 'mobile' in value ) {
			oneCss[ 'sm' ] = {
				[ styleName ]: value[ 'mobile' ],
			};
		}
		return oneCss;
	}
}

function AlphaTypographyControl( attributes, keyName, defaultValue = false ) {
	let typography = {};
	let _kebabKeyName = camelToKebab( keyName );
	if ( keyName in attributes ) {
		let fontFamily = AlphaOptionControl(
			attributes[ keyName ],
			'fontFamily'
		);
		typography = {
			...typography,
			...AlphaOptionControl(
				attributes[ keyName ],
				'fontFamily',
				'',
				keyName
			),
			...AlphaOneDControl(
				attributes[ keyName ],
				'fontSize',
				'',
				keyName
			),
			...AlphaOptionControl(
				attributes[ keyName ],
				'fontWeight',
				'',
				keyName
			),
			...AlphaOptionControl(
				attributes[ keyName ],
				'fontStyle',
				'',
				keyName
			),
			...AlphaOptionControl(
				attributes[ keyName ],
				'fontTransform',
				'',
				keyName
			),
			...AlphaOptionControl(
				attributes[ keyName ],
				'fontDecoration',
				'',
				keyName
			),
			...AlphaOptionControl(
				attributes[ keyName ],
				'fontLineHeight',
				'',
				keyName
			),
			...AlphaOptionControl(
				attributes[ keyName ],
				'fontLetterSpacing',
				'',
				keyName
			),
		};
	} else if ( defaultValue ) {
		typography = {};
	}
	return typography;
}

function CssLengthValue( propDetails, defaultValue = 0 ) {
	if ( 'desktop' in propDetails ) {
		return `${ propDetails?.desktop?.val ?? defaultValue }${
			propDetails?.desktop?.unit ?? 'px'
		}`;
	}
	return `${ propDetails?.val ?? defaultValue }${ propDetails?.unit ?? '' }`;
}

function CssBorderWidthValue( propDetails, defaultValue = [ 0, 0, 0, 0 ] ) {
	if ( 'desktop' in propDetails ) {
		let {
			borderTop: top = defaultValue[ 0 ],
			borderRight: right = defaultValue[ 1 ],
			borderBottom: bottom = defaultValue[ 2 ],
			borderLeft: left = defaultValue[ 3 ],
			unit = 'px',
		} = propDetails.desktop;
		return {
			borderWidth: `${ top }${ unit } ${ right }${ unit } ${ bottom }${ unit } ${ left }${ unit }`,
		};
	}
}

function CssTypography( propDetails ) {
	const {
		fontFamily = false,
		fontSize = {},
		fontWeight = false,
		fontStyle = false,
		fontTransform = false,
		fontDecoration = false,
		fontLineHeight = {},
		fontLetterSpacing = {},
	} = propDetails;

	const typography = {};

	if ( Object.keys( fontSize ).length > 0 ) {
		typography[ 'font-size' ] = CssLengthValue( fontSize, '14px' );
	}
	if ( fontFamily !== false && fontFamily !== 'default' ) {
		typography[ 'font-family' ] = fontFamily;
	}
	if ( fontWeight !== false && fontWeight !== 'default' ) {
		typography[ 'font-weight' ] = fontWeight;
	}
	if ( fontStyle !== false && fontStyle !== 'default' ) {
		typography[ 'font-style' ] = fontStyle;
	}
	if ( fontTransform !== false && fontTransform !== 'default' ) {
		typography[ 'font-transform' ] = fontTransform;
	}
	if ( fontDecoration !== false && fontDecoration !== 'default' ) {
		typography[ 'text-decoration' ] = fontDecoration;
	}
	if ( Object.keys( fontLineHeight ).length > 0 ) {
		typography[ 'line-height' ] = CssLengthValue(
			fontLineHeight,
			'normal'
		);
	}
	if ( Object.keys( fontLetterSpacing ).length > 0 ) {
		typography[ 'letter-spacing' ] = CssLengthValue(
			fontLetterSpacing,
			'normal'
		);
	}

	return { initial: typography };
}

function CssBackground( propDetails, defaultValue = '' ) {
	if (
		propDetails &&
		[ 'type' ] in propDetails &&
		'gradient' == propDetails.type
	) {
		return {
			initial: {
				'background-image': propDetails?.gradient ?? '',
			},
		};
	}
	if ( propDetails?.color ) {
		return {
			initial: {
				'background-color': propDetails?.color,
			},
		};
	}
	if ( defaultValue ) {
		return {
			initial: {
				'background-color': defaultValue,
			},
		};
	}
}

function CssBackgroundImage( propDetails, defaultValue = '' ) {
	/*
    id: media.id,
    url: media.url,
    alt
  */

	if (
		propDetails &&
		[ 'url' ] in propDetails &&
		Boolean( propDetails.url )
	) {
		const {
			url,
			backgroundSize,
			backgroundPosition,
			backgroundRepeat,
			backgroundAttachment,
		} = propDetails;

		const styles = {
			'background-image': `url(${ url })`,
		};

		if ( backgroundSize ) {
			styles[ 'background-size' ] = backgroundSize;
		}
		if ( backgroundPosition ) {
			styles[ 'background-position' ] = backgroundPosition;
		}
		if ( backgroundRepeat ) {
			styles[ 'background-repeat' ] = backgroundRepeat;
		}
		if ( backgroundAttachment ) {
			styles[ 'background-attachment' ] = backgroundAttachment;
		}

		return { initial: styles };
	}
}

function CssBackgroundImageGradient(bg) {
  const {
    enableBackground = true,
    backgroundType = 'color-gradient',
    backgroundColorGradient,
    backgroundImage,
    backgroundImageUrl,
    backgroundOpacity,
  } = bg || {};

  const opacity = backgroundOpacity?.desktop?.val ? backgroundOpacity.desktop.val / 100 : 1;

  const applyOpacityToColor = (color) => {
    if (color.startsWith('rgba')) {
      return color.replace(/,\s*[0-9.]+\s*\)/, `, ${opacity})`);
    } else if (color.startsWith('rgb')) {
      return color.replace(')', `, ${opacity})`).replace('rgb', 'rgba');
    } else if (color.startsWith('#')) {
      const r = parseInt(color.slice(1, 3), 16);
      const g = parseInt(color.slice(3, 5), 16);
      const b = parseInt(color.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }
    return color;
  };

  if (!enableBackground) {
    return undefined;
  }

  if (backgroundType === 'color' || backgroundType === 'color-gradient') {
    if (backgroundColorGradient?.type === 'gradient') {
      const gradientWithOpacity = backgroundColorGradient.gradient.replace(/rgba?\(.+?\)/g, (match) => {
        return applyOpacityToColor(match);
      });
      return {
        initial: {
          'background-image': gradientWithOpacity,
        },
      };
    } else if (backgroundColorGradient?.color) {
      return {
        initial: {
          'background-color': applyOpacityToColor(backgroundColorGradient.color),
        },
      };
    }
  }

  if (backgroundType === 'image') {
    return CssBackgroundImage({ url: backgroundImage?.url, ...bg });
  }

  if (backgroundType === 'url') {
    return CssBackgroundImage({ url: backgroundImageUrl, ...bg });
  }

  return undefined;
}

function CssTextColor( propDetails, defaultValue = '' ) {
	if (
		propDetails &&
		[ 'type' ] in propDetails &&
		propDetails.type === 'gradient' &&
		propDetails.gradient
	) {
		return {
			initial: {
				background: propDetails.gradient,
				'-webkit-background-clip': 'text',
				'-webkit-text-fill-color': 'transparent',
				'background-clip': 'text',
				color: 'transparent',
			},
		};
	}
	if ( propDetails?.color ) {
		return {
			initial: {
				color: propDetails?.color,
			},
		};
	}
	if ( defaultValue ) {
		return {
			initial: {
				color: defaultValue,
			},
		};
	}
}

function CssFillColor( propDetails, defaultValue = '' ) {
	if (
		propDetails &&
		[ 'type' ] in propDetails &&
		propDetails.type === 'gradient' &&
		propDetails.gradient
	) {
		return {
			initial: {
				background: propDetails.gradient,
				'-webkit-background-clip': 'text',
				'-webkit-text-fill-color': 'transparent',
				'background-clip': 'text',
				fill: 'transparent',
			},
		};
	}
	if ( propDetails?.color ) {
		return {
			initial: {
				fill: propDetails?.color,
			},
		};
	}
	if ( defaultValue ) {
		return {
			initial: {
				fill: defaultValue,
			},
		};
	}
}

function CssZIndex( propDetails, defaultValue = 1 ) {
	return {
		initial: { [ 'z-index' ]: propDetails?.desktop?.val ?? defaultValue },
	};
}

function CssBorder(
	propDetails,
	defaultValue = { color: '#333', style: 'solid', width: '2px' }
) {
	let _propDetails = propDetails ?? defaultValue;
	// If split border (top, right, bottom, left) from BorderBoxControl
	if (
		_propDetails &&
		typeof _propDetails === 'object' &&
		( 'top' in _propDetails ||
			'right' in _propDetails ||
			'bottom' in _propDetails ||
			'left' in _propDetails )
	) {
		const borderCss = {};
		// Helper to get value or fallback
		const getVal = ( side, key, fallback ) =>
			_propDetails?.[ side ]?.[ key ] ?? defaultValue[ key ] ?? fallback;
		// Top
		if ( _propDetails.top ) {
			borderCss[ 'border-top' ] = `${ getVal(
				'top',
				'width',
				'2px'
			) } ${ getVal( 'top', 'style', 'solid' ) } ${ getVal(
				'top',
				'color',
				'#333'
			) }`;
		}
		// Right
		if ( _propDetails.right ) {
			borderCss[ 'border-right' ] = `${ getVal(
				'right',
				'width',
				'2px'
			) } ${ getVal( 'right', 'style', 'solid' ) } ${ getVal(
				'right',
				'color',
				'#333'
			) }`;
		}
		// Bottom
		if ( _propDetails.bottom ) {
			borderCss[ 'border-bottom' ] = `${ getVal(
				'bottom',
				'width',
				'2px'
			) } ${ getVal( 'bottom', 'style', 'solid' ) } ${ getVal(
				'bottom',
				'color',
				'#333'
			) }`;
		}
		// Left
		if ( _propDetails.left ) {
			borderCss[ 'border-left' ] = `${ getVal(
				'left',
				'width',
				'2px'
			) } ${ getVal( 'left', 'style', 'solid' ) } ${ getVal(
				'left',
				'color',
				'#333'
			) }`;
		}
		return { initial: borderCss };
	}
	// Fallback: single border
	return {
		initial: {
			[ 'border' ]: `${ _propDetails?.width } ${ _propDetails?.style } ${ _propDetails?.color }`,
		},
	};
}

function CssPropOneD( attributes, keyName, cb = ( val ) => val ) {
	return {
		initial: {
			[ `--${ camelToKebab( keyName ) }` ]:
				cb( attributes?.[ keyName ] ) ?? 0,
		},
	};
}

function cssString( Arr ) {
	let css = '';
	if ( Array.isArray( Arr ) && Arr.length ) {
		let styleObj = Arr.reduce(
			( acc, item ) => ( { ...acc, ...item } ),
			{}
		);
		// console.log("Arr:", styleObj);
		for ( const itemKey of Object.keys( styleObj ) ) {
			if ( itemKey ) {
				css += itemKey + ':' + styleObj?.[ itemKey ] + ';';
			}
		}
	}
	return css;
}

function GenerateStyle( CssObj ) {
	let initialCss = '';
	let lgCss = '';
	let mdCss = '';
	let smCss = '';

	for ( const selector of Object.keys( CssObj ) ) {
		initialCss +=
			selector +
			'{' +
			cssString(
				CssObj?.[ selector ]?.map( ( item ) => item?.initial )
			) +
			'}';

		let lgValue = cssString(
			CssObj?.[ selector ]?.map( ( item ) => item?.lg )
		);
		if ( lgValue ) {
			lgCss += selector + '{' + lgValue + '}';
		}
		let mdValue = cssString(
			CssObj?.[ selector ]?.map( ( item ) => item?.md )
		);
		if ( mdValue ) {
			mdCss += selector + '{' + mdValue + '}';
		}
		let smValue = cssString(
			CssObj?.[ selector ]?.map( ( item ) => item?.sm )
		);
		if ( smValue ) {
			smCss += selector + '{' + smValue + '}';
		}
	}
	let _lgCss = lgCss ? `@media (min-width: 769px){${ lgCss }}` : '';
	let _mdCss = mdCss
		? `@media (min-width: 641px) and (max-width: 768px ) {${ mdCss }}`
		: '';
	let _smCss = smCss ? `@media (max-width: 640px){${ smCss }}` : '';

	let _compliedCss = `${ initialCss } ${ _lgCss } ${ _mdCss } ${ _smCss }`;

	// console.log("_compliedCss: ", _compliedCss);

	return <style>{ _compliedCss }</style>;
}

export {
	AlphaOneDCss,
	AlphaFourDCss,
	displayControl,
	GenerateStyle,
	CssPropOneD,
	CssBorderWidthValue,
	CssZIndex,
	CssBorder,
	CssBackground,
	CssBackgroundImageGradient,
	CssTextColor,
	CssFillColor,
	CssTypography,
	AlphaBackground,
	AlphaBackgroundCSS,
	AlphaOneDControl,
	AlphaOptionControl,
	AlphaBorderStyleCSS,
	AlphaTypographyControl,
	CSS,
	cssString,
};
